import type { Components, Theme } from '@mui/material/styles';

const MuiSvgIcon: Components<Theme>['MuiSvgIcon'] = {
  defaultProps: {
    fontSize: 'inherit'
  }
};

export default MuiSvgIcon;
